import { forwardRef, type PropsWithChildren } from "react";

import { Button, type ButtonProps } from "./button";

export const SecondaryButton = forwardRef<
  HTMLButtonElement,
  PropsWithChildren<Omit<ButtonProps, "variant">>
>(({ children, ...props }, ref) => {
  return (
    <Button ref={ref} variant="secondary" {...props}>
      {children}
    </Button>
  );
});
